<app-header [id]="auctionId()" [shareSocialMediaData]="{type: 'auction', id:auctionId()}" [hideShoppingCart]="true"></app-header>

<div class="container mx-auto px-5 lg:px-10">
  <h1 class="text-2xl lg:text-3xl font-bold font-mulish my-6">Checkout</h1>
  <div class="flex flex-col items-center">
    @if (loadingDone()) {
      @if (items().length < 1 && donations().length < 1) {
        <div class="flex justify-center w-full">
          <div class="bg-white shadow-md rounded-lg text-center max-w-full md:max-w-[60%] mb-4">
            <p class="text-xl mx-6 mt-4">Your cart is empty, add some items to it!</p>
            <button [routerLink]="['/auction', auctionId()]"
                    class="!rounded-2xl px-4 py-2 mb-4 !text-[var(--p-text-color-primary)] bg-[var(--p-primary-500)] hover:bg-[var(--p-primary-600)] focus:bg-[var(--p-primary-700)]">
              Go to Homepage
            </button>
          </div>
        </div>
      } @else {
        <div class="w-full md:w-[40rem] lg:w-[50rem] bg-white rounded-lg shadow-md px-4 pb-4">
          @if (items().length > 0) {
            <h2 class="text-xl">Items:</h2>
            @for (item of items(); track $index) {
              <app-checkout-element [currency]="currency()" [lineItem]="item" (updateElementSignal)="updateElement($event)" (removeElementSignal)="removeElement($event)" />
            }
          }
          @if (donations().length > 0) {

            <h2>Donations:</h2>
            @for (donation of donations(); track $index) {
              <p>DonationAmount: {{donation.donationAmount}}</p>
            }
          }
        </div>

        <div class="flex justify-center mt-6">
          <button class="!rounded-2xl sm:w-[300px] w-full px-4 py-2 mb-4 !text-[var(--p-text-color-primary)] bg-[var(--p-primary-500)] hover:bg-[var(--p-primary-600)] focus:bg-[var(--p-primary-700)]"
                  (click)="openLoginModal()">
            <div class="flex justify-between">
              <fa-icon [icon]="icons.faCreditCard" />
              <span class="text-">Proceed with Payment</span>
              <span class="w-4"><!-- empty on purpose to center button --></span>
            </div>
          </button>
        </div>
      }
    }
  </div>
</div>

<app-embedded-payment [token]="token()" [visible]="showEPF()" (visibleChange)="setEpfVisibility($event)"></app-embedded-payment>
